import { reactive } from 'vue';
import _ from "lodash";

import { UserInfoStore } from '@/stores/UserInfoStore';
import router, { pathForNavKey } from '@/router';

export const NavigationStore = reactive({
    adminRoutes: [
        'items.create',
        'items.company'
    ],
    changeListeners: {
    },
    isCollapsed: false,
    items: {
        dashboard: true,
        create: false,
        settings: false,
        surveys: false,
        reports: false,
        company: false,
    },
    mobileMapView: false,
    anyOpen() {
        return _.some(this.items, (v) => v === true);
    },
    closeItem(key) {
        if (_.has(this, key)) {
            _.set(this, key, false);
        }
    },
    getSelectedKey() {
        const key = _.findKey(this.items, (value) => value === true);
        return `items.${key}`;
    },
    isSelected(key) {
        return _.get(this, key, false);
    },
    registerChangeListener(name, callback) {
        this.changeListeners[name] = callback;
    },
    /**
     * Navigate to the given item key (e.g. "items.surveys"). Drives the router,
     * which is the source of truth; the router sync then activates the item.
     */
    toggleItem(key) {
        if (!_.has(this, key)) {
            return;
        }
        const navKey = key.replace(/^items\./, "");
        const path = pathForNavKey(navKey);
        if (router.currentRoute.path !== path) {
            router.push(path).catch(() => {});
        } else {
            // Already on this route — re-activate (fires listeners, e.g. clears state).
            this.setActiveItem(navKey);
        }
    },
    /**
     * Sets the active item directly (used by the router sync). Does not navigate.
     */
    setActiveItem(navKey) {
        Object.keys(this.items).forEach((k) => {
            this.items[k] = k === navKey;
        });
        _.forEach(this.changeListeners, (listener) => listener());
    },
    shouldShow(key) {
        const isAdminRoute = _.includes(this.adminRoutes, key);
        if (isAdminRoute) {
            return UserInfoStore.admin;
        }
        return true;
    },
    unregisterChangeListener(name) {
        delete this.changeListeners[name];
    }
})